import { useState } from "react";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");

    const res = await fetch("/api/admin/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ password }),
    });

    const data = await res.json();

    setLoading(false);

    if (data.success) {
      window.location.href = "/";
    } else {
      setError(data.message || "Wrong password. Please try again.");
      setPassword("");
    }
  }

  return (
    <div className="admin-login-page">
      <div className="admin-container">
        <div className="admin-logo">
          <img src="/logo-horizontal.png" alt="Comfort Companions logo" />
        </div>

        <h1 className="admin-title">Admin Login</h1>

        <p className="admin-login-intro">
          Please enter your admin password to access the dashboard.
        </p>

        <form className="admin-code-screen" onSubmit={handleSubmit}>
          <label htmlFor="adminPassword">Admin password:</label>

          <input
            id="adminPassword"
            type="password"
            maxLength={32}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            disabled={loading}
          />

          <button type="submit" disabled={loading || !password}>
            {loading ? "Checking..." : "Login"}
          </button>

          {error && <span className="admin-error">{error}</span>}
        </form>
      </div>
    </div>
  );
}